import { ActionTypes } from "../constantes/ActionTypes";

const initialState = {
  data: [],
  isLoading: false,
  error: "",
};
export const ShipmentByUserReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.ACTION_SHIPMENT_BY_USER_INIT:
      return initialState;
    case ActionTypes.ACTION_SHIPMENT_BY_USER_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.ACTION_SHIPMENT_BY_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
        error: "",
      };
    case ActionTypes.ACTION_SHIPMENT_BY_USER_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
